"use client";
import type { Actor } from "@-/prisma";
import { createContext } from "react";

export type ActorLayoutContext = {
  actorUser: Actor;
};

export default createContext<ActorLayoutContext>(null!);
